import classNames from 'classnames';
import { forwardRef } from 'react';
import { FieldRenderProps } from 'react-final-form';

import './TextareaField.styles.scss';

type TextareaFieldProps = FieldRenderProps<string, HTMLElement> & {
  label?: string;
  className?: string;
  placeholder?: string;
};

export const TextareaField = forwardRef<
  HTMLTextAreaElement,
  TextareaFieldProps
>((props, ref) => {
  const { input, meta, label, className, placeholder, ...rest } = props;

  return (
    <div className={classNames('textarea-field', className)}>
      {label && <label>{label}</label>}

      <textarea
        {...input}
        {...rest}
        placeholder={placeholder}
        ref={ref}
        className={classNames('custom-textarea', {
          'has-error': meta.touched && meta.error,
        })}
      />

      {meta.touched && meta.error && (
        <small className="error-text">{meta.error}</small>
      )}
    </div>
  );
});

export default TextareaField;
